import {HTHGameConfig} from "../../HTHGameConfig";


export class EnhancerSpinView extends PIXI.Container {

    private _reelID: number;


    constructor(id: number) {
        super();
        this.name = "Reel " + id;
        this._reelID = id;

        this.position.set(id * HTHGameConfig.symbolWidth, 0);

    }

}